export default __webpack_public_path__ + "static/media/1.b6b1c9dd.png";